// MPIN Manager - Handles MPIN storage, verification, and relogin functionality

// Store MPIN in local storage
export const storeMpin = (userId, mpin) => {
  try {
    const hashedMpin = btoa(mpin); // demo only (replace with proper KDF in production)
    const mpinData = {
      mpin: hashedMpin,
      mpinSetAt: new Date(),
      userId: userId
    };
    localStorage.setItem('user_mpin', JSON.stringify(mpinData));
    return true;
  } catch (error) {
    console.error('Error storing MPIN locally:', error);
    return false;
  }
};

// Verify MPIN from local storage
export const verifyMpin = (userId, inputMpin) => {
  try {
    const localMpin = localStorage.getItem('user_mpin');
    if (!localMpin) return false;
    
    const mpinData = JSON.parse(localMpin);
    if (mpinData.userId !== userId) return false;
    
    const hashedInput = btoa(inputMpin);
    return mpinData.mpin === hashedInput;
  } catch (error) {
    console.error('Error verifying MPIN:', error);
    return false;
  }
};

// Check if MPIN is set for user
export const isMpinSet = (userId) => {
  try {
    const localMpin = localStorage.getItem('user_mpin');
    if (!localMpin) return false;
    
    const mpinData = JSON.parse(localMpin);
    return mpinData.userId === userId && !!mpinData.mpin;
  } catch (error) {
    console.error('Error checking MPIN status:', error);
    return false;
  }
};

// Clear MPIN from local storage
export const clearMpin = (userId) => {
  try {
    const localMpin = localStorage.getItem('user_mpin');
    if (localMpin) {
      const mpinData = JSON.parse(localMpin);
      if (mpinData.userId === userId) {
        localStorage.removeItem('user_mpin');
        return true;
      }
    }
    return false;
  } catch (error) {
    console.error('Error clearing MPIN:', error);
    return false;
  }
};

// Check if user needs MPIN relogin (for app restart scenarios)
export const needsMpinRelogin = (userId) => {
  try {
    // Check if user was previously logged in but app was closed
    const lastLogin = localStorage.getItem('last_login');
    const sessionExpiry = localStorage.getItem('session_expiry');
    
    if (!lastLogin || !sessionExpiry) return false;
    
    const now = new Date().getTime();
    const expiry = parseInt(sessionExpiry);
    
    // If session expired and MPIN is set, require MPIN relogin
    if (now > expiry && isMpinSet(userId)) {
      return true;
    }
    
    return false;
  } catch (error) {
    console.error('Error checking MPIN relogin requirement:', error);
    return false;
  }
};

// Set session expiry for MPIN relogin logic
export const setSessionExpiry = (hours = 720) => { // 30 days = 720 hours
  try {
    const now = new Date().getTime();
    const expiry = now + (hours * 60 * 60 * 1000); // hours to milliseconds
    localStorage.setItem('last_login', now.toString());
    localStorage.setItem('session_expiry', expiry.toString());
  } catch (error) {
    console.error('Error setting session expiry:', error);
  }
};

// Clear session data (on logout)
export const clearSession = () => {
  try {
    localStorage.removeItem('last_login');
    localStorage.removeItem('session_expiry');
  } catch (error) {
    console.error('Error clearing session:', error);
  }
};

// MPIN relogin component data
export const getMpinReloginData = () => {
  return {
    needsRelogin: needsMpinRelogin,
    verifyMpin: verifyMpin,
    isMpinSet: isMpinSet,
    clearMpin: clearMpin
  };
};